
import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface GenerateReportParams {
  reportType: 'financial' | 'fiscal' | 'trends';
  format: 'pdf' | 'excel';
  startDate: string;
  endDate: string;
  psychologistId?: string;
}

export const useReportGenerator = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const { user } = useAuth();

  const generateReport = async (params: GenerateReportParams) => {
    if (!user) {
      toast.error('Usuário não autenticado');
      return;
    }

    console.log('🚀 Iniciando geração de relatório:', params);
    setIsGenerating(true);
    
    try {
      // Verificar se a edge function existe antes de chamar
      const { data, error } = await supabase.functions.invoke('generate-financial-report', {
        body: params
      });

      console.log('📊 Resposta da edge function:', { data, error });

      if (error) {
        console.error('❌ Erro na edge function:', error);
        throw new Error(error.message || 'Erro ao gerar relatório');
      }

      if (data?.success && data.downloadUrl) {
        // Fazer download do arquivo
        const link = document.createElement('a');
        link.href = data.downloadUrl;
        link.download = data.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        toast.success('Relatório gerado e baixado com sucesso!');
        return data;
      } else {
        console.error('❌ Resposta inválida:', data);
        throw new Error('URL de download não encontrada na resposta');
      }
    } catch (error: any) {
      console.error('❌ Erro ao gerar relatório:', error);
      
      // Verificar se é erro de função não encontrada
      if (error.message?.includes('Function not found')) {
        toast.error('Funcionalidade de relatórios temporariamente indisponível');
      } else if (error.message?.includes('Unauthorized')) {
        toast.error('Você não tem permissão para gerar relatórios');
      } else {
        toast.error(`Erro ao gerar relatório: ${error.message}`);
      }
      throw error;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    generateReport,
    isGenerating
  };
};
